import styled from 'styled-components';
import MiniBarSvg from '../../assets/amenities/mini-bar.svg';

const MiniBarIcon = styled(MiniBarSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default MiniBarIcon;
